import PublicNav from "../../components/PublicNav";
import Footer from "../../components/Footer";
import Seo from "../../components/Seo";

export default function Partners() {
  return (
    <div className="public-shell">
      <Seo
        title="Partner"
        description="Mystery Served is expanding. Become a local market partner or a Clue Stop venue. Email info@mysteryserved.com to learn more."
        url="https://mysteryserved.com/partners"
      />
      <PublicNav />

      {/* INTRO */}
      <section className="bg-ms-cream pt-40 md:pt-48 pb-16 md:pb-20" data-testid="partners-intro">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center animate-fade-up">
          <p className="label-eyebrow text-ms-brass" data-testid="partners-eyebrow">Partner</p>
          <h1 className="serif text-ms-ink text-5xl md:text-7xl mt-5 leading-[0.95]" data-testid="partners-headline">
            Own a Piece of the <span className="italic text-ms-brass">Mystery</span>
          </h1>
          <p className="mt-8 text-ms-stone text-base md:text-lg leading-[1.75] max-w-2xl mx-auto" data-testid="partners-intro-body">
            Mystery Served is expanding — and we're looking for passionate local partners and businesses who want to be part of something people talk about. Whether you want to bring the full experience to your city or simply open your doors to our guests, there's a place for you in the Mystery Served world.
          </p>
        </div>
      </section>

      {/* SECTION 1 — Local Partner */}
      <section className="bg-ms-cream py-20 md:py-28" data-testid="partners-local-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20 items-start">
          <div className="md:col-span-5">
            <p className="label-eyebrow text-ms-brass">Section 01</p>
            <p className="serif italic text-ms-ink/70 text-xl md:text-2xl mt-6 leading-[1.45]">
              Become a Local Partner.
            </p>
          </div>
          <div className="md:col-span-7">
            <h2 className="serif text-ms-ink text-4xl md:text-5xl leading-[1.05]" data-testid="partners-local-headline">
              Bring Mystery Served to your city.
            </h2>
            <div className="mt-8 space-y-5 text-ms-stone text-base leading-[1.75] max-w-xl">
              <p data-testid="partners-local-body">
                Mystery Served local partners own the experience in their market. You get a fully built booking and player platform, tour builder tools to create your own adventures, brand assets, templates, and direct support from the Mystery Served team. Territories are exclusive — one partner per market. Pricing is based on your city's size and tourism potential. Let's talk.
              </p>
            </div>
            <a
              href="mailto:info@mysteryserved.com?subject=Local%20Partner%20Inquiry"
              className="btn-primary-dark mt-10 !py-3.5 !px-7 inline-block"
              data-testid="partners-local-cta"
            >
              Email Us to Learn More
            </a>
          </div>
        </div>
      </section>

      {/* HAIRLINE DIVIDER */}
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="hairline" />
      </div>

      {/* SECTION 2 — Clue Stop */}
      <section className="bg-ms-cream py-20 md:py-28" data-testid="partners-clue-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20 items-start">
          <div className="md:col-span-5">
            <p className="label-eyebrow text-ms-brass">Section 02</p>
            <p className="serif italic text-ms-ink/70 text-xl md:text-2xl mt-6 leading-[1.45]">
              Become a Clue Stop.
            </p>
          </div>
          <div className="md:col-span-7">
            <h2 className="serif text-ms-ink text-4xl md:text-5xl leading-[1.05]" data-testid="partners-clue-headline">
              Get your business on the map.
            </h2>
            <div className="mt-8 space-y-5 text-ms-stone text-base leading-[1.75] max-w-xl">
              <p data-testid="partners-clue-body">
                Clue stops are the heartbeat of every Mystery Served tour. Guests arrive on a mission, engage with your space, and leave with a memory they'll talk about. It's foot traffic with a story. If you're a restaurant, shop, gallery, or local business in a Mystery Served city, we'd love to hear from you.
              </p>
            </div>
            <a
              href="mailto:info@mysteryserved.com?subject=Clue%20Stop%20Inquiry"
              className="btn-primary-dark mt-10 !py-3.5 !px-7 inline-block"
              data-testid="partners-clue-cta"
            >
              Tell Us About Your Business
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
